module.exports = "/_next/static/images/0301839c2fb510350db64196b3a00313-payment_where.png";